import React, { useEffect, useState } from 'react';
import './Header.scss';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as Logo } from '../../assets/icons/logo.svg';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { Button, EButtonType } from '@repo/apg-ui';
import { FormattedMessage } from 'react-intl';

const Header = () => {
  const navigate = useNavigate();
  const [language, setLanguage] = useState({ value: 'de', label: 'DE' });

  const handleLanguageChange = (newLang: any) => {
    sessionStorage.setItem('apg_dc_language', newLang.value);
    setLanguage(newLang);
    window.location.reload();
  };

  const options = [
    { value: 'de', label: 'DE' },
    { value: 'en', label: 'EN' },
    { value: 'fr', label: 'FR' },
    { value: 'it', label: 'IT' },
  ];

  useEffect(() => {
    const language = sessionStorage.getItem('apg_dc_language');

    const languageObj = options.find((option) => option.value === language);

    if (languageObj) {
      setLanguage(languageObj);
    }
  }, []);

  const animatedComponents = makeAnimated();

  return (
    <div className='w-100 p-4 d-flex justify-content-start center justify-content-between'>
      <div>
        <a className={'logo'} href={'https://apgsga.ch/'} target={'_blank'}>
          <Logo />
        </a>

        <Button
          buttonType={EButtonType.BasicLink}
          onClick={() => {
            navigate('/?modal=calculation');
          }}
        >
          <FormattedMessage id={'ec.checkout.newCalculation'} defaultMessage={'Neue Kalkulation starten'} />
        </Button>
        {/*    <Button className={"ps-4"} buttonType={EButtonType.BasicLink} onClick={() => {*/}
        {/*        navigate('/refine-results')*/}
        {/*    }}>*/}
        {/*        <FormattedMessage*/}
        {/*            id={'home.button.ViewResults'}*/}
        {/*            defaultMessage={'View results'}*/}
        {/*        />*/}
        {/*    </Button>*/}
      </div>

      <div className='language-switcher d-flex align-items-center p-2 flex-row gap-4 mr-3'>
        <Select
          defaultValue={language}
          onChange={(newValue) => handleLanguageChange(newValue)}
          components={animatedComponents}
          value={language}
          options={options as any}
          isSearchable={false}
          isClearable={false}
          styles={{
            control: (baseStyles, state) => ({
              ...baseStyles,
              backgroundColor: '#FFFFFF',
              border: '1px solid #E0E0E0',
              boxShadow: 'none',
              '&:hover': {
                border: '1px solid #B30200',
              },
              fontSize: '14px',
              cursor: 'pointer',
            }),
            singleValue: (baseStyles) => ({
              ...baseStyles,
              color: '#000',
              fontSize: '14px',
            }),
            option: (baseStyles, { isFocused }) => ({
              ...baseStyles,
              backgroundColor: isFocused ? '#E0E0E0' : '#F8F8F8',
              color: '#000',
              cursor: 'pointer',
              fontSize: '14px',
              '&:hover': {
                backgroundColor: '#B30200',
                color: '#fff',
              },
            }),
            menu: (baseStyles) => ({
              ...baseStyles,
              zIndex: 999999,
            }),
          }}
        />
      </div>
    </div>
  );
};

export default Header;
